<template>
  <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="视频" name="first">
      <v-video></v-video>
    </el-tab-pane>
    <el-tab-pane label="音频" name="second">
      <v-radio></v-radio>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import video from './video'
import radio from './radioWave'
export default {
  components: {
    'v-video': video,
    'v-radio': radio
  },
  data() {
    return {
      activeName: "first",
      guideId: "",
      list: []
    }
  },

  methods: {
    handleClick() {
    }
   
  },

  mounted() {
   
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  /deep/.el-tabs__nav-wrap {
    &::after{
      display: none;
    }
    .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
    }
  }
}
</style>